import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import './Blog.css'
import Header from '../Header/header'
import blogData from './blogData'

const Blogall = () => {
  return (
    <div>
      <Header />
      <Helmet>
        <title>Skin & Hair Care Blog – Sharva Clinique</title>
        <meta
          name='description'
          content='Helpful, dermatologist-informed blogs on laser hair reduction, pigmentation, acne, chemical peels, HydraFacial, hair fall, and more from Sharva Clinique.'
        />
      </Helmet>
      <div>
        <div className='blogbanner'>
          <div className='heroheadblogline'>
            <h1 className=''>Because Informed Patients Feel Confident.</h1>
            <p className='' style={{ fontFamily: 'inherit' }}>
              Helpful blogs covering treatments, recovery, results, and preventive care.
            </p>
          </div>
        </div>
        <div className='blogcards'>
          {blogData.map((post) => (
            <Link to={`/blog/${post.slug}`} className='blogcard1' key={post.slug}>
              <div className='blogimage'>
                <img src={post.image} alt={post.title} />
              </div>
              <span className='blogcategory'>{post.category}</span>
              <h3 className=''>{post.title}</h3>
              <p className='blogexcerpt'>{post.excerpt}</p>
              <span className='blogreadmore'>Read More &raquo;</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Blogall
